const url = "/api/v1/setup_intents";

export interface SetupIntentsIndexResponse {
  clientSecret: string;
}

export const setupIntentsIndexQuery = () => ({
  url,
});
